import { computed } from 'vue'
import { useAppStore } from '@/store/modules/app'
import SysMenu from './Menu.vue'
import AppView from './AppView.vue'
import ToolHeader from './ToolHeader.vue'
import { ElContainer, ElScrollbar } from 'element-plus'
import { useDesign } from '@/hooks/web/useDesign'
import TagView from './TagView.vue'
import { useRoute } from 'vue-router'

const { Header, Aside, Main } = ElContainer
const { getPrefixCls } = useDesign()

const prefixCls = getPrefixCls('layout')



export const useRenderLayout = () => {

  const appStore = useAppStore()
  const route = useRoute()

  const pageLoading = computed(() => appStore.getPageLoading)

  // 是否隐藏TagView（通过路由meta配置）
  const hideTagView = computed(() => route.meta?.hideTagView === true)

  // 菜单折叠
  const collapse = computed(() => appStore.getCollapse)
  // 标签页
  //  const tagsView = computed(() => appStore.getTagsView)
  //   // logo
  //   const logo = computed(() => appStore.logo)

  //   // 固定头部
  //   const fixedHeader = computed(() => appStore.getFixedHeader)

  //   // 是否是移动端
  // const mobile = computed(() => appStore.getMobile)

  //   // 固定菜单
  //   const fixedMenu = computed(() => appStore.getFixedMenu)

  const renderTopLeft = () => {
    return (
      <>
        <ElContainer class="h-full">
          <Aside class={`${collapse.value ? 'w-16' : 'w-52'} h-full overflow-y-auto no-scrollbar`}>
            <SysMenu class="!h-full relative layout-border__right"></SysMenu>
          </Aside>

          <ElContainer class={`min-h-0`}>
            <Header class={`border-b theme-border`}>
              <ToolHeader class="flex-1"></ToolHeader>
            </Header>
            <ElContainer class={`min-h-0`}>
            {!hideTagView.value && (
              <Header class={`h-12 border-b theme-border px-0`}>
                <TagView></TagView>
              </Header>
            )}
              <Main class={`p-0`} style="background-color: var(--app-content-bg-color)">
                <ElScrollbar
                  v-loading={pageLoading.value}
                  class={[
                    `${prefixCls}-content-scrollbar`,
                  ]}
                >

                  <AppView></AppView>
                </ElScrollbar>
              </Main>
            </ElContainer>

          </ElContainer>
        </ElContainer>
      </>
    )
  }



  return {
    renderTopLeft,
  }
}
